export default "__VITE_ASSET__B_9osVRu__"